import { useIntl } from 'react-intl'

type CustomerSupportTexts = {
  entireWeekLabel: string
  freeCallDisclaimerText: string
  getPhoneNumber: () => string
  getTimeframe: () => string
  paidCallDisclaimerText: string
  weekdaysLabel: string
}

export const useDirectContactFormTelephoneTranslations = (
  isPharmaModal: boolean,
): CustomerSupportTexts => {
  const intl = useIntl()

  const freeCallDisclaimerText = intl.formatMessage({
    id: 'contact.directContactSection.customerSupportDialog.freeCallDisclaimer',
  })

  const paidCallDisclaimerText = intl.formatMessage({
    id: 'contact.directContactSection.customerSupportDialog.priceDisclaimer',
  })

  const weekdaysLabel = intl.formatMessage({
    id: 'contact.directContactSection.customerSupportDialog.weekdays.label',
  })

  const entireWeekLabel = intl.formatMessage({
    id: 'contact.directContactSection.customerSupportDialog.entireWeek.label',
  })

  const getTimeframe = (): string => {
    if (isPharmaModal) {
      return intl.formatMessage({
        id: 'contact.directContactSection.customerSupportDialog.availableTimeframe.pharma',
      })
    }

    return intl.formatMessage({
      id: 'contact.directContactSection.customerSupportDialog.availableTimeframe',
    })
  }

  const getPhoneNumber = (): string => {
    if (isPharmaModal) {
      return intl.formatMessage({
        id: 'contact.directContact.customerSupport.phoneNumber.pharma',
      })
    }

    return intl.formatMessage({
      id: 'contact.directContact.customerSupport.phoneNumber',
    })
  }

  return {
    entireWeekLabel,
    freeCallDisclaimerText,
    getPhoneNumber,
    getTimeframe,
    paidCallDisclaimerText,
    weekdaysLabel,
  }
}
